import { render, staticRenderFns } from "./RelListClientes.vue?vue&type=template&id=23ec95e8"
import script from "./RelListClientes.vue?vue&type=script&lang=js"
export * from "./RelListClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports